"use client"

/**
 * Danger triangle when a question needs author attention.
 *
 * Same mark on the section roster, the Add-questions pool table, and the
 * bank panel list — one tip copy so the reasons never drift between surfaces.
 */

export const NEEDS_REVIEW_ROW_BG = "var(--status-badge-danger-fill)"

import { Tip } from "@/components/ui/tip"
import { cn } from "@/lib/utils"

export function NeedsReviewMark({
  reasons,
  title = "Needs review",
  className,
}: {
  reasons: readonly string[]
  title?: string
  className?: string
}) {
  if (reasons.length === 0) return null

  const label = `${title}: ${reasons.join(", ")}`

  return (
    <Tip label={label}>
      <span
        role="img"
        aria-label={label}
        data-needs-review=""
        tabIndex={0}
        className={cn(
          "inline-flex size-6 shrink-0 items-center justify-center rounded-1 text-[var(--status-badge-danger-fg)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          className
        )}
      >
        <i
          className="fa-solid fa-triangle-exclamation text-xs"
          aria-hidden
        />
      </span>
    </Tip>
  )
}
